import { State, useHookstate } from '@hookstate/core'
import { Col, Row, Tooltip } from 'antd'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { getItemChangesByJobUseCase } from '../../../application/get-item-changes-by-job.use-case'
import { ItemChanges, JobItem } from '../../../domain/items'
import { itemRepository } from '../../odin-nebula-item.repository'
import { ItemStatusBar } from './item-status-bar.component'
import { InfoCircleOutlined } from '@ant-design/icons'

const ItemStatusSectionContainer = styled.div`
  margin: 1.6rem;
  background: #f3f5f9;
  padding: 1rem;
  border-radius: 0.8rem;
  & > div {
    & > div {
      & > label:nth-child(1) {
        color: #000000d9;
        font-size: 1.6rem;
        font-weight: 700;
      }
      & > label:nth-child(3) {
        color: #1677ff;
        font-size: 1.2rem;
        font-weight: 700;
        cursor: pointer;
      }
      & > span {
        color: #1677ff;
        font-size: 1.2rem;
        font-weight: 700;
        cursor: pointer;
    }
  }
`

type ItemStatusSectionProps = {
  items: State<JobItem[]>
  jobId: string
  showItemChangesSection: State<boolean>
  itemChanges: State<ItemChanges[]>
  historyItemsQuantity: number
}

const ItemStatusSection = (porps: ItemStatusSectionProps) => {
  const { items, jobId, showItemChangesSection, itemChanges, historyItemsQuantity } = porps
  const { t } = useTranslation()
  const itemStatusTitle = useHookstate<string>(t<string>('itemChangesNotStarted'))

  useEffect(() => {
    getItemChanges(jobId)
  }, [])

  const getItemChanges = async (jobId) => {
    const itemChangesResponse: ItemChanges[] = await getItemChangesByJobUseCase(itemRepository)(jobId)
    itemChanges.set(itemChangesResponse)
  }

  return (
    <ItemStatusSectionContainer>
      <Row>
        <Col span={24}>
          <label>{itemStatusTitle.get()}</label>

          <ItemStatusBar items={items} showStatusLabel={true} itemStatusTitle={itemStatusTitle} />

          {itemChanges.get().length > 0 && (
            <label onClick={() => showItemChangesSection.set(true)}>
              {t<string>('changeHistory')} ({historyItemsQuantity})
            </label>
          )}
          {itemChanges.get().length === 0 && <label>{t<string>('itemChangesInfoNoChangesText')} </label>}

          <Tooltip title={t<string>('itemChangesInfoTooltip')}>
            <InfoCircleOutlined />
          </Tooltip>
        </Col>
      </Row>
    </ItemStatusSectionContainer>
  )
}

export { ItemStatusSection }
